import CardPostFormCreateContainer from './CardPostFormCreateContainer';
import CardPostFormUpdateContainer from './CardPostFormUpdateContainer';

interface Props {
  closeModal: () => void;
  isEditMode: boolean;
  cardId: string;
}

const CardPostFormContainer = ({ isEditMode, cardId, ...props }: Props) => {
  if (isEditMode) {
    return <CardPostFormUpdateContainer {...props} />;
  }
  return <CardPostFormCreateContainer cardId={cardId} {...props} />;
};

CardPostFormContainer.displayName = 'CardPostFormContainer';

export default CardPostFormContainer;
